import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  tone?: 'default' | 'inverse';
}

export default function Breadcrumbs({ items, tone = 'default' }: BreadcrumbsProps) {
  const isInverse = tone === 'inverse';
  const baseText = isInverse ? 'text-background-300/80' : 'text-foreground-500';
  const linkHover = isInverse ? 'hover:text-accent-400' : 'hover:text-primary-600';
  const currentText = isInverse ? 'text-background-100' : 'text-foreground-800';
  const separator = isInverse ? 'text-background-300/50' : 'text-foreground-300';

  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-[13px]">
      <ol className={`flex flex-wrap items-center gap-2 ${baseText}`}>
        <li>
          <Link to="/" className={`transition-colors ${linkHover}`}>
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className={`ri-arrow-right-s-line ${separator}`} aria-hidden="true" />
            {item.to ? (
              <Link to={item.to} className={`transition-colors ${linkHover}`}>
                {item.label}
              </Link>
            ) : (
              <span className={`max-w-[60vw] truncate md:max-w-md ${currentText}`}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}